var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"is-align-items-center is-flex is-flex-direction-column is-justify-content-center"},[_c(_vm.stepComponent,{tag:"component",on:{"next":_vm.stepAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }